export const getStatusInvitationsInitialState = {
	invitations: undefined,
	loading: false,
	error: null,
	errorShow: false,
	getData: false,
};
